import React from 'react';
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {PolIcon} from "components/PolIcon/policon";
import useViewOrdersConfigButtonConditionalField
    from "v4/pages/admin/ViewOrders/components/ViewOrdersButtons/ViewOrdersConfigButton/components/ViewOrdersConfigButtonConditionalField/hooks/useViewOrdersConfigButtonConditionalField";

export default function ViewOrdersConfigButtonConditionalField({group, field, config}) {
    const {t} = usePolTranslation();
    const {
        submenuRef,
        listFields,
        listFieldKeyChosen,
        hasEnoughSpace,
        onListFieldKeyChoose,
        onSelect,
    } = useViewOrdersConfigButtonConditionalField(group, field, config);

    return (
        <ul className={`vo-action__config__item__submenu ${listFieldKeyChosen ? 'active' : ''} ${hasEnoughSpace ? '' : 'to-right'}`}
            ref={submenuRef}>
            {listFields.map(([listFieldKey, listField]) => {
                let listFieldKeyPrefix = '';
                if (listField.attr?.['data-type'] === 'specific-fields') {
                    listFieldKeyPrefix = 'sf_';
                }
                const isActive = field.conditionField === `${listFieldKeyPrefix}${listFieldKey}`;

                return (
                    <li key={listFieldKey}
                        className="vo-action__config__item__submenu__item"
                        onClick={onListFieldKeyChoose(listFieldKey)}
                    >
                        {isActive ? <PolIcon icon="validation"/> : <span/>} {/* Empty span to keep the same width */}
                        {t(listField.title)}

                        <div
                            className={`vo-action__config__item__submenu ${listFieldKeyChosen === listFieldKey ? 'show' : ''}`}>
                            <button className="vo-action__config__item__submenu__button"
                                    onClick={onListFieldKeyChoose(null)}>
                                <PolIcon icon="arrow-left"/> {t(listField.title)}
                            </button>
                            <ul>
                                {(listField.items?.enum_titles ?? listField.enum_titles ?? [])?.map((title, enumIndex) => {
                                    const isActive = (field.conditionField === `${listFieldKeyPrefix}${listFieldKey}` && field.conditionValue?.includes(listField.items?.enum?.[enumIndex] ?? listField.enum?.[enumIndex])) ?? false;

                                    return (
                                        <li key={enumIndex}
                                            data-choice={listField.enum?.[enumIndex]}
                                            className="vo-action__config__item__submenu__item"
                                            onClick={onSelect(listFieldKey, listField, enumIndex)}
                                        >
                                            {isActive ? <PolIcon icon="validation"/> : <span/>}
                                            {t(title)}
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </li>
                )
            })}
        </ul>
    )
}
